import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageBellNotification() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addData(data) {
    return Promise.resolve({});
  }

  function updateData({ id: commentId, ...rest } = {}) {
    return privateFetch.put(`/v1/admin/comments/${commentId}/markAsRead`, rest);
  }

  function manageES(data) {
    if (data.id) return updateData(data);

    return addData(data);
  }

  return useMutation(manageES, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('user-action-centre');
    },
  });
}

export default useManageBellNotification;
